module.exports = __webpack_public_path__ + "img/dashboard-stat-2.28121be7.svg";